import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { AttachFile } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 220,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #ff7043 0%, #ffa270 100%)",
    boxShadow: "0 4px 12px rgba(255, 112, 67, 0.4)",
    border: "2px solid #ff7043",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(255, 112, 67, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  nodeIcon: { fontSize: 20 },
  nodeLabel: { fontWeight: 600, fontSize: 14, color: "white" },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
  },
  nodeFooter: { fontSize: 11, opacity: 0.85, marginTop: theme.spacing(0.5) },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #ff7043",
    borderRadius: "50%",
  },
}));

const ETIQUETAS = {
  image: "imagen",
  video: "video",
  audio: "audio",
  document: "documento",
};

/** Entrada de archivo (0419 P2.2): pide un fichero y espera hasta recibirlo. */
const FileInputNode = ({ data, selected }) => {
  const classes = useStyles();
  const peticion = data?.text || data?.message || "Sin texto de petición";
  const admitidos = Array.isArray(data?.accept) ? data.accept : [];

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(255, 112, 67, 0.6)"
          : "0 4px 12px rgba(255, 112, 67, 0.4)",
      }}
    >
      <NodePorts color="#ff7043" />
      <Box className={classes.nodeHeader}>
        <AttachFile className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Pedir archivo</Typography>
      </Box>
      <Box className={classes.nodeContent}>{peticion}</Box>
      <Typography className={classes.nodeFooter}>
        {admitidos.length
          ? `Admite: ${admitidos.map((t) => ETIQUETAS[t] || t).join(", ")}`
          : "Admite cualquier archivo"}
      </Typography>
    </Box>
  );
};

export default FileInputNode;
